const menuConfig = [
  { path: '/', name: 'index', title: '网站首页', static: true },
  { path: '/driver', name: 'driver', title: '我是承运人', static: false },
  { path: '/shipper', name: 'shipper', title: '我是货主', static: false },
  { path: '/about-us', name: 'about-us', title: '关于我们', static: true },
  { path: '/services', name: 'services', title: '技术优势', static: true },
  // { path: '/news', name: 'news', title: '咨询投诉', static: true },
  { path: '/freightInfo', name: 'freightInfo', title: '货源信息', static: true },
  // { path: '/publishFreightInfo', name: 'publishFreightInfo', title: '发布信息', static: true },
  { path: '/QuestionFeedback', name: 'QuestionFeedback', title: '问题反馈', static: true }
];

export default menuConfig;


// WEBPACK FOOTER //
// ./src/menuConfig.js